import { Contact, ScheduleItem, Supplier, SupportType } from 'app/dataTypes/cabinet/support/SupportTypes'

import type { Request } from '../index'


export type SupportParams = {}


export type SupportResult = {
  instructions_url?: string,
  questions_url?: string,
  schedule: {
    [wday: string]: ScheduleItem,
  },
  contacts: Array<Contact>,
  suppliers?: Array<Supplier>,
  result?: string,
}

export const defaultState: SupportType = {
  instructionsUrl: '',
  questionsUrl: '',
  schedule: {},
  contacts: [],
  suppliers: [],
  result: null,
}

export const convertResult = (settings: SupportResult): SupportType => {
  return {
    instructionsUrl: settings.instructions_url,
    questionsUrl: settings.questions_url,
    schedule: settings.schedule,
    contacts: settings.contacts,
    suppliers: settings.suppliers,
    result: settings.result,
  }
}

export const GET_SUPPORT_INFO: Request<void, SupportResult, void> = [
  'cabinet/support',
  'get',
  ['data'],
]
